import { useEffect } from "react";

export function useKeydown(handler: (e: KeyboardEvent) => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const f = (e: KeyboardEvent) => handler(e);
    window.addEventListener("keydown", f);
    return () => window.removeEventListener("keydown", f);
  }, [handler, enabled]);
}
